import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useState } from "react";
import AudioDropZone from "../../components/forms/AudioDropZone";
import SwitchToggle from "../../components/forms/SwitchToggle";
import ContainerSm from "../../components/Layouts/ContainerSm";
import { submitCandidatesRecord } from "../../api/endpoints/candidate/cadidates";
import PlaceHolder from "../../components/placeHolder.tsx/PlaceHolder";
import imgPlaceholder from "../../assets/img/session-placeholeder.png";
import AppLogo from "../../components/AppLogo";
import { makeApiRequest } from "../../helpers";
import toast from "react-hot-toast";
import { useAuth } from "../../context/AuthContext";

function AudioUploadPage() {
  const Context = useAuth();
  const navigate = useNavigate();
  const [signedId, setSignedId] = useState<any>(null);
  const [isUpload, setIsUpload] = useState<any>(false);
  const [isSubmitedSuccess, setIsSubmitedSuccess] = useState<boolean>(false);
  const [switchButton, setSwitchButton] = useState(false);
  const { t } = useTranslation("", { keyPrefix: "page.audioUpload" });
  let { user_id } = useParams();

  const submitAudioRecord = () => {
    return submitCandidatesRecord({
      sound_record: signedId,
      candidate_uuid: user_id,
    });
  };

  const handleSubmit = () => {
    if (isUpload) return toast.error(t("waitUploading"));
    if (!signedId) return toast.error(t("pleaseUpload"));
    if (!switchButton) return toast.error(t("pleaseAgree"));
    makeApiRequest(submitAudioRecord, () => setIsSubmitedSuccess(true));
  };

  return (
    <ContainerSm>
      <AppLogo />
      {!isSubmitedSuccess ? (
        <>
          <h2 className="mt-6  text-3xl font-extrabold text-gray-900">
            {t("title", { name: Context?.currentUser?.firstName })}
          </h2>
          <p className="mt-2  text-sm text-gray-600">{t("subTitle")}</p>
          <div className="mt-8">
            <label
              htmlFor={"ASfdd"}
              className="block text-sm font-medium text-gray-700"
            >
              {t("audioFile")}
            </label>
            <AudioDropZone onUpload={setSignedId} isUploading={setIsUpload} />
          </div>
          <div className="mt-8">
            <SwitchToggle enabled={switchButton} setEnabled={setSwitchButton}>
              <span className="px-1 text-sm text-gray-600">
                {t("agreement.one")}
              </span>
              <Link
                to={"/policies"}
                className="px-1 text-sm underline underline-offset-1 font-bold "
              >
                {t("agreement.two")}
              </Link>
              <span className="px-1 text-sm text-gray-600 ">
                {t("agreement.three")}
              </span>
              <Link
                to={"/policies"}
                className="px-1 text-sm underline underline-offset-1 font-bold"
              >
                {t("agreement.four")}
              </Link>
            </SwitchToggle>
          </div>

          <div className="mt-8 ">
            <div className="mt-6">
              <div className="mt-12">
                <button
                  onClick={handleSubmit}
                  type="button"
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-brandblue-600 disabled:bg-brandblue-300 hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500"
                >
                  {t("send")}
                </button>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="w-full  flex justify-center items-center ">
            <PlaceHolder
              img={imgPlaceholder}
              title="submitYourAudioFile"
              description="submitYourAudioFileDescription"
            />
          </div>
        </>
      )}
    </ContainerSm>
  );
}
export default AudioUploadPage;
